import { QueryClient, isServer } from '@tanstack/react-query';

// Singleton instance for browser
let browserClient: QueryClient | undefined;

// Create a new QueryClient with minimal config
const createQueryClient = () =>
	new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 60 * 1000, // 1 minute
				refetchOnWindowFocus: false,
			},
		},
	});

/**
 * Get QueryClient instance - new for server, singleton for browser
 */
export const getQueryClient = () => {
	if (isServer) {
		return createQueryClient();
	}

	if (!browserClient) {
		browserClient = createQueryClient();
	}

	return browserClient;
};
